import { useCallback, useContext, useEffect, useState } from "react";

import { ZeosApiContext } from "../context/ZeosApiContext";
import {
  IEspmPropertyTypeCategoryNode,
  IEspmPropertyTypeTaxonomyResponse,
} from "../services/zeos-api/contracts/EspmPropertyType";
import { setEspmTaxonomyForValidation } from "../services/forms/validationSchemas/espmTaxonomyValidationContext";

export function useEspmPropertyTypeTaxonomy() {
  const api = useContext(ZeosApiContext);
  const [categories, setCategories] = useState<IEspmPropertyTypeCategoryNode[]>(
    []
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await api.EspmPropertyType.getTaxonomyAsync();
      const data: IEspmPropertyTypeTaxonomyResponse | null | undefined =
        response.data;
      const next = data?.categories ?? [];
      setCategories(next);
      setEspmTaxonomyForValidation(next);
    } catch (err) {
      console.error("Failed to load ESPM property type taxonomy", err);
      setError("Failed to load property types");
      setCategories([]);
      setEspmTaxonomyForValidation([]);
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    void reload();
  }, [reload]);

  return { categories, loading, error, reload };
}
